/*
  Kischt CRO batch 1 (1 Nov 2026). Loaded on every page by snippets/kischt-cro.liquid, which also
  supplies the settings and the wording (#kcroData: English, or French for language fr; UK and
  France get metric fit ranges, their own currency, threshold and delivery days).
  Works alongside assets/kischt-pack-buybox.js, assets/kischt-page-fixes.js, assets/kischt-story.js
  and snippets/kischt-tights-upgrades.liquid without changing them.

  1. Email pop-up: a tap on the dark overlay closes it and the close button gets a 44 px target.
     (The timing gate is the inline script in snippets/kischt-cro.liquid.)
  2. Product photos open a full-screen photo viewer: swipe, pinch or double-tap to zoom.
     Story "Swipe to see more" lines scroll their photo row.
  3. Feedback on buttons that did nothing: quantity minus at 1, "Add" on the shade cards before a
     size, taps on a shade card, on the selected shade, on the shade guide rows, and on the skin
     tone question in the size and shade finder. Close buttons get a bigger target (CSS).
  4. Fleece tights: one compact line next to the sticky Add to cart with the star rating and
     review count (only when the product has reviews), the fit range from the size chart, the
     60-day Fit-or-Free, free shipping over the market threshold and the delivery dates.
  5. Free shipping progress bar in the buy box bag, and the 3-pack chosen by default on single
     pages with packs, only when the address has no variant (Google Shopping links keep the
     variant they name) or other selection.

  CRO batch 2 (1 Nov 2026), see "CRO batch 2" below:
  - Size hint from the line's size chart ("Not sure? 5'10", 150 lb = M") in the first-screen line
    and under the size buttons; it opens the existing size and shade finder (or the size guide).
  - First-screen line: fit range and size hint, 60-day Fit-or-Free, "Arrives by <date>" and the
    standard shipping charge ("$4.95 shipping, free over $50", by market).
  - Under Add to cart: delivery date and charge, and the Fit-or-Free and returns terms of the
    refund policy (replaces the arrival and Christmas lines of the tights upgrades).
  - "Arrives by <date>" next to business-day ranges on the product page and in the cart.
  - 3-pack button marked as the recommended pack; single by default on Thermal and Sheer Look.
  - One-tap "Upgrade to the 3-pack" in the bag, the theme cart drawer and the cart page.
  - Express checkout at the top of the bag; shipping charge, date and guarantee in the bag.
  - Black Friday (until 1 Dec): pack price after 20% off near the price, "20% off at checkout"
    on the 3-pack and 6-pack buttons, and "Black Friday 20% off applied to packs" in the bag.
*/
(function () {
  'use strict';

  var DATA = {};
  try {
    DATA = JSON.parse(document.getElementById('kcroData').textContent) || {};
  } catch (e) {
    DATA = {};
  }
  var COPY = DATA.copy || {};
  var MARKET = DATA.market || {};

  function t(key, values) {
    var text = String(COPY[key] || '');
    Object.keys(values || {}).forEach(function (k) {
      text = text.split('{' + k + '}').join(values[k]);
    });
    return text;
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function moneyLocale() {
    if (DATA.lang === 'fr') return 'fr-FR';
    if (MARKET.country === 'GB') return 'en-GB';
    if (MARKET.country === 'FR') return 'en-IE';
    return 'en-US';
  }

  function money(cents, currency) {
    currency = currency || MARKET.currency || 'USD';
    var value = Number(cents) / 100;
    try {
      return new Intl.NumberFormat(moneyLocale(), {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: value % 1 ? 2 : 0, maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + currency;
    }
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  // Shows a short message next to an element and points at it.
  function note(anchor, text, info, id) {
    if (!anchor || !anchor.parentNode) return null;
    var el = id ? document.getElementById(id) : null;
    if (!el) {
      el = document.createElement('p');
      el.className = 'kcro-note';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      if (id) el.id = id;
      anchor.insertAdjacentElement('afterend', el);
    }
    el.classList.toggle('is-info', !!info);
    el.textContent = text;
    el.hidden = false;
    clearTimeout(el._kcroTimer);
    el._kcroTimer = setTimeout(function () { el.hidden = true; }, 5000);
    return el;
  }

  function attention(el) {
    if (!el) return;
    el.classList.remove('kcro-attention');
    void el.offsetWidth;
    el.classList.add('kcro-attention');
    setTimeout(function () { el.classList.remove('kcro-attention'); }, 1000);
  }

  // ---------------------------------------------------------------------------
  // 1. Email pop-up close behaviour (Shopify Forms app embed, open shadow root)
  // ---------------------------------------------------------------------------
  function setupPopup() {
    var POPUP_CSS =
      '[class*="_formContainerCloseButtonPosition_"]{top:15px!important;right:14px!important;width:44px!important;height:44px!important;display:flex!important;align-items:center!important;justify-content:center!important}' +
      '[class*="_formCloseButton_"]{display:flex!important;align-items:center!important;justify-content:center!important;width:44px!important;height:44px!important;cursor:pointer!important}' +
      '[class*="_overlayBackground_"]{cursor:pointer}';

    function closeButton(root) {
      return root.querySelector('[class*="_formCloseButton_"]');
    }
    function overlay(root) {
      return root.querySelector('[class*="_overlay_"][role="dialog"], section[class*="_overlay_"]');
    }

    function wire(host) {
      var root = host.shadowRoot;
      if (!root || host._kcroWired) return !!host._kcroWired;
      host._kcroWired = true;

      function addStyle() {
        if (root.querySelector('style[data-kcro]')) return;
        var style = document.createElement('style');
        style.setAttribute('data-kcro', '');
        style.textContent = POPUP_CSS;
        root.appendChild(style);
      }
      addStyle();

      // A tap on the dark overlay closes the pop-up, the same way as its close button.
      root.addEventListener('click', function (e) {
        var ov = overlay(root);
        if (!ov) return;
        var target = e.target;
        var outside = target === ov || (target.matches && target.matches('[class*="_overlayBackground_"]'));
        if (!outside) return;
        setTimeout(function () {
          var still = overlay(root);
          var btn = closeButton(root);
          if (still && btn) btn.click();
        }, 60);
      });

      // While the timing gate keeps it hidden, the hidden form must not hold keyboard focus.
      function sync() {
        addStyle();
        var gateOpen = document.documentElement.getAttribute('data-kcro-forms') === 'open';
        if (!gateOpen && document.activeElement === host) host.blur();
      }
      new MutationObserver(sync).observe(root, { childList: true, subtree: true });
      document.addEventListener('kcro:popup-gate-open', function () {
        var ov = overlay(root);
        var box = ov && ov.querySelector('[class*="_formContainer_"]');
        if (box && box.focus) box.focus({ preventScroll: true });
      });
      sync();
      return true;
    }

    function scan() {
      var found = false;
      document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
        if (wire(host)) found = true;
      });
      return found;
    }

    if (!scan()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (scan() || tries > 60) clearInterval(timer);
      }, 500);
    }
  }

  // ---------------------------------------------------------------------------
  // 2a. Photo viewer for the pack buy box gallery
  // ---------------------------------------------------------------------------
  function largest(img) {
    var best = img.currentSrc || img.src || '';
    var bestW = 0;
    String(img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10);
      if (bits[0] && w > bestW) { bestW = w; best = bits[0]; }
    });
    // Ask the Shopify CDN for a sharper copy for zooming.
    if (/[?&]width=\d+/.test(best)) best = best.replace(/([?&]width=)\d+/, '$12000');
    return best;
  }

  var viewer = null;

  function buildViewer() {
    if (viewer) return viewer;
    var box = document.createElement('div');
    box.className = 'kcro-lb';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', t('viewer'));
    box.innerHTML =
      '<div class="kcro-lb-track"></div>' +
      '<button type="button" class="kcro-lb-btn kcro-lb-close" aria-label="' + esc(t('viewerClose')) + '">&times;</button>' +
      '<button type="button" class="kcro-lb-btn kcro-lb-prev" aria-label="' + esc(t('viewerPrev')) + '">&#8249;</button>' +
      '<button type="button" class="kcro-lb-btn kcro-lb-next" aria-label="' + esc(t('viewerNext')) + '">&#8250;</button>' +
      '<div class="kcro-lb-foot"><span class="kcro-lb-count" aria-live="polite"></span><span class="kcro-lb-hint">' + esc(t('viewerHint')) + '</span></div>';
    document.body.appendChild(box);

    var track = box.querySelector('.kcro-lb-track');
    var count = box.querySelector('.kcro-lb-count');
    var opener = null;
    var total = 0;
    var zoom = { scale: 1, x: 0, y: 0, img: null };
    var pointers = new Map();
    var pinch = null;
    var pan = null;
    var lastTap = 0;
    var moved = false;

    function index() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(total - 1, Math.round(track.scrollLeft / w)));
    }
    function updateCount() {
      count.textContent = t('viewerCount', { index: index() + 1, total: total });
    }
    function apply() {
      if (!zoom.img) return;
      zoom.img.style.transform = zoom.scale === 1 ? '' :
        'translate(' + zoom.x + 'px,' + zoom.y + 'px) scale(' + zoom.scale + ')';
      box.classList.toggle('is-zoomed', zoom.scale > 1);
    }
    function reset() {
      if (zoom.img) zoom.img.style.transform = '';
      zoom = { scale: 1, x: 0, y: 0, img: null };
      box.classList.remove('is-zoomed');
    }
    function clamp() {
      var img = zoom.img;
      if (!img) return;
      var slide = img.parentNode;
      var sw = slide.clientWidth, sh = slide.clientHeight;
      var iw = img.offsetWidth * zoom.scale, ih = img.offsetHeight * zoom.scale;
      var left = img.offsetLeft, top = img.offsetTop;
      // Keep the zoomed photo covering the screen where it can.
      var minX = Math.min(0, sw - left - iw), maxX = Math.max(0, -left);
      var minY = Math.min(0, sh - top - ih), maxY = Math.max(0, -top);
      if (iw <= sw) { minX = maxX = (sw - iw) / 2 - left; }
      if (ih <= sh) { minY = maxY = (sh - ih) / 2 - top; }
      zoom.x = Math.max(minX, Math.min(maxX, zoom.x));
      zoom.y = Math.max(minY, Math.min(maxY, zoom.y));
    }
    // Zoom so the point (cx, cy) on screen stays under the finger.
    function zoomAt(img, scale, cx, cy) {
      if (zoom.img !== img) reset();
      zoom.img = img;
      var rect = img.getBoundingClientRect();
      var px = (cx - rect.left) / zoom.scale;
      var py = (cy - rect.top) / zoom.scale;
      scale = Math.max(1, Math.min(4, scale));
      zoom.x = zoom.x + px * zoom.scale - px * scale;
      zoom.y = zoom.y + py * zoom.scale - py * scale;
      zoom.scale = scale;
      if (scale === 1) { zoom.x = 0; zoom.y = 0; }
      clamp();
      apply();
    }

    track.addEventListener('scroll', function () {
      if (zoom.scale === 1) updateCount();
    }, { passive: true });

    track.addEventListener('pointerdown', function (e) {
      var img = e.target.closest && e.target.closest('.kcro-lb-slide img');
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY, sx: e.clientX, sy: e.clientY });
      if (pointers.size === 1) moved = false;
      if (pointers.size === 2) {
        moved = true;
        var p = Array.from(pointers.values());
        var targetImg = img || (zoom.img) || track.children[index()].querySelector('img');
        pinch = {
          img: targetImg,
          dist: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1,
          scale: zoom.img === targetImg ? zoom.scale : 1
        };
        pan = null;
        if (track.setPointerCapture) try { track.setPointerCapture(e.pointerId); } catch (_) {}
      } else if (pointers.size === 1 && zoom.scale > 1) {
        pan = { x: e.clientX, y: e.clientY, ox: zoom.x, oy: zoom.y };
        if (track.setPointerCapture) try { track.setPointerCapture(e.pointerId); } catch (_) {}
      }
    });
    track.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      var start = pointers.get(e.pointerId);
      if (Math.abs(e.clientX - start.sx) > 8 || Math.abs(e.clientY - start.sy) > 8) moved = true;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY, sx: start.sx, sy: start.sy });
      if (pinch && pointers.size === 2) {
        var p = Array.from(pointers.values());
        var dist = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1;
        zoomAt(pinch.img, pinch.scale * dist / pinch.dist, (p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2);
        e.preventDefault();
      } else if (pan && zoom.scale > 1) {
        zoom.x = pan.ox + (e.clientX - pan.x);
        zoom.y = pan.oy + (e.clientY - pan.y);
        clamp();
        apply();
        e.preventDefault();
      }
    });
    function up(e) {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinch = null;
      if (!pointers.size) pan = null;
    }
    track.addEventListener('pointerup', up);
    track.addEventListener('pointercancel', up);

    // Double-tap (or double-click) toggles zoom; a single tap beside the photo closes.
    track.addEventListener('click', function (e) {
      if (moved) return;
      var img = e.target.closest && e.target.closest('.kcro-lb-slide img');
      var now = Date.now();
      if (img) {
        if (now - lastTap < 320) {
          lastTap = 0;
          if (zoom.scale > 1 && zoom.img === img) zoomAt(img, 1, e.clientX, e.clientY);
          else zoomAt(img, 2.5, e.clientX, e.clientY);
        } else {
          lastTap = now;
          // Mouse users zoom with one click.
          if (e.pointerType === 'mouse' || (!('ontouchstart' in window) && e.detail === 1)) {
            setTimeout(function () {
              if (lastTap !== now) return;
              lastTap = 0;
              if (zoom.scale > 1 && zoom.img === img) zoomAt(img, 1, e.clientX, e.clientY);
              else zoomAt(img, 2.5, e.clientX, e.clientY);
            }, 330);
          }
        }
      } else if (zoom.scale === 1 && e.target.classList && e.target.classList.contains('kcro-lb-slide')) {
        close();
      }
    });

    box.addEventListener('wheel', function (e) {
      if (!e.ctrlKey) return;
      var img = zoom.img || (track.children[index()] && track.children[index()].querySelector('img'));
      if (!img) return;
      e.preventDefault();
      zoomAt(img, zoom.scale * (e.deltaY < 0 ? 1.15 : 0.87), e.clientX, e.clientY);
    }, { passive: false });

    function go(step) {
      reset();
      var next = Math.max(0, Math.min(total - 1, index() + step));
      track.scrollTo({ left: next * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }
    box.querySelector('.kcro-lb-prev').addEventListener('click', function () { go(-1); });
    box.querySelector('.kcro-lb-next').addEventListener('click', function () { go(1); });
    box.querySelector('.kcro-lb-close').addEventListener('click', function () { close(); });

    function onKey(e) {
      if (box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(box.querySelectorAll('button')).filter(function (b) { return b.offsetParent !== null; });
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
      }
    }

    function open(images, start, from) {
      opener = from || document.activeElement;
      reset();
      total = images.length;
      track.innerHTML = images.map(function (im, i) {
        return '<div class="kcro-lb-slide" role="group" aria-label="' + esc(t('viewerCount', { index: i + 1, total: images.length })) + '">' +
          '<img src="' + esc(im.src) + '" alt="' + esc(im.alt) + '" draggable="false" decoding="async"' + (Math.abs(i - start) > 1 ? ' loading="lazy"' : '') + '></div>';
      }).join('');
      box.hidden = false;
      document.addEventListener('keydown', onKey, true);
      document.documentElement.classList.add('kcro-lb-lock');
      track.scrollLeft = start * track.clientWidth;
      requestAnimationFrame(function () { track.scrollLeft = start * track.clientWidth; updateCount(); });
      updateCount();
      box.querySelector('.kcro-lb-close').focus({ preventScroll: true });
    }
    function close() {
      reset();
      box.hidden = true;
      document.removeEventListener('keydown', onKey, true);
      track.innerHTML = '';
      document.documentElement.classList.remove('kcro-lb-lock');
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    window.addEventListener('resize', function () {
      if (box.hidden) return;
      var i = index();
      reset();
      track.scrollLeft = i * track.clientWidth;
    });

    viewer = { open: open, close: close };
    return viewer;
  }

  function setupGalleryViewer(root) {
    var viewport = root.querySelector('#kpuGalleryViewport');
    if (!viewport) return;

    function photos() {
      return Array.prototype.slice.call(viewport.querySelectorAll('.kpu-gallery-slide img')).filter(function (img) {
        return img.getAttribute('src') || img.getAttribute('srcset');
      });
    }
    function openAt(img) {
      var list = photos();
      if (!list.length) return;
      var start = Math.max(0, list.indexOf(img));
      buildViewer().open(list.map(function (im) {
        return { src: largest(im), alt: im.getAttribute('alt') || '' };
      }), start, viewport);
    }

    // A tap anywhere on the main photo (not a drag; the buy box stops those) opens the viewer.
    viewport.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      if (e.target.closest && e.target.closest('button, a, video, .kpu-video-overlay, .kpu-model-size')) return;
      var slide = e.target.closest && e.target.closest('.kpu-gallery-slide');
      var img = slide ? slide.querySelector('img') : null;
      if (!img) {
        var active = viewport.querySelector('.kpu-gallery-slide[aria-hidden="false"] img');
        img = active || photos()[0];
      }
      if (img) openAt(img);
    });
    viewport.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target !== viewport) return;
      var active = viewport.querySelector('.kpu-gallery-slide[aria-hidden="false"] img') || photos()[0];
      if (active) { e.preventDefault(); openAt(active); }
    });
    if (!viewport.getAttribute('title')) viewport.setAttribute('title', t('viewerOpen'));
  }

  // ---------------------------------------------------------------------------
  // 2b. Story "Swipe to see more" lines scroll their photo row
  // ---------------------------------------------------------------------------
  function railFor(noteEl) {
    var el = noteEl.previousElementSibling;
    while (el) {
      if (el.matches('.kp-photo-rail, .kp-view-grid, [class*="rail"]')) return el;
      var inner = el.querySelector && el.querySelector('.kp-photo-rail, .kp-view-grid');
      if (inner) return inner;
      el = el.previousElementSibling;
    }
    var parent = noteEl.parentElement;
    return parent ? parent.querySelector('.kp-photo-rail, .kp-view-grid') : null;
  }

  function setupSwipeNotes(scope) {
    (scope || document).querySelectorAll('.kp-swipe-note').forEach(function (noteEl) {
      if (noteEl.classList.contains('kcro-swipe')) return;
      var rail = railFor(noteEl);
      if (!rail) return;
      noteEl.classList.add('kcro-swipe');
      noteEl.setAttribute('role', 'button');
      noteEl.setAttribute('tabindex', '0');
      noteEl.setAttribute('aria-label', t('swipeMore'));
      if (rail.id) noteEl.setAttribute('aria-controls', rail.id);

      function step() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 2) return;
        var card = rail.firstElementChild;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        var by = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.85;
        var next = rail.scrollLeft + by;
        if (rail.scrollLeft >= max - 4) next = 0;
        rail.scrollTo({ left: Math.min(next, max), behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
      noteEl.addEventListener('click', step);
      noteEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); step(); }
      });
    });
  }

  // ---------------------------------------------------------------------------
  // 3. Feedback on buttons that did nothing
  // ---------------------------------------------------------------------------
  function setupFeedback(root) {
    function $(id) { return root.querySelector('#' + id) || document.getElementById(id); }

    function chosenSize() {
      var sizes = $('kpuSizes');
      var pressed = sizes && sizes.querySelector('[aria-pressed="true"]');
      return pressed ? pressed.getAttribute('data-kpu-size') : '';
    }

    // Quantity minus at 1: the button is disabled, so its row hears the tap.
    var qtyRow = root.querySelector('.kpu-quantity-control');
    var minus = $('kpuQuantityMinus');
    if (qtyRow && minus) {
      qtyRow.addEventListener('click', function (e) {
        if (!minus.disabled) return;
        var r = minus.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
        note(root.querySelector('.kpu-quantity-row') || qtyRow, t('qtyMin'), true, 'kcroQtyNote');
      });
    }

    // Shade cards ("Build your rotation" and the bag): "Add" before a size, or a tap on the card.
    function cardFeedback(card) {
      var select = card.querySelector('select');
      var add = card.querySelector('[data-kpu-upsell-add]');
      var actions = card.querySelector('.kpu-upsell-actions') || card;
      if (select && !select.value) {
        note(actions, t('chooseSize'), false);
        attention(select);
        select.focus({ preventScroll: false });
        if (typeof select.showPicker === 'function') {
          try { select.showPicker(); } catch (_) {}
        }
      } else if (add && !add.disabled) {
        attention(add);
        add.focus({ preventScroll: false });
      }
    }
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-kpu-upsell]');
      if (!card) return;
      if (e.target.closest('select, option, [data-kpu-upsell-add]:not(:disabled), a')) return;
      var add = card.querySelector('[data-kpu-upsell-add]');
      if (add && add.disabled) {
        // A tap on the disabled Add button lands on its row.
        var r = add.getBoundingClientRect();
        var onAdd = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (onAdd || e.target.closest('.kpu-upsell-info, .kpu-upsell-photo, .kpu-upsell-actions')) cardFeedback(card);
        return;
      }
      if (e.target.closest('.kpu-upsell-info, .kpu-upsell-photo')) cardFeedback(card);
    });

    // The shade already selected: say so instead of nothing.
    var colours = $('kpuColours');
    if (colours) {
      colours.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-kpu-colour]');
        if (!btn || btn.getAttribute('aria-pressed') !== 'true') return;
        var name = (btn.querySelector('.kpu-colour-name') || btn).textContent.trim();
        var hasSize = !!chosenSize();
        note(colours, t(hasSize ? 'shadeSelected' : 'shadeSelectedSize', { name: name }), true, 'kcroShadeNote');
        if (!hasSize) attention($('kpuSizes'));
      }, true);
    }

    // Shade guide rows (plain text with a swatch dot): a tap picks that shade.
    function wireShadeGuide() {
      root.querySelectorAll('.kpt-shade-help li').forEach(function (li) {
        if (li.classList.contains('kcro-shade-row')) return;
        var strong = li.querySelector('strong');
        if (!strong) return;
        var name = strong.textContent.replace(/[:\s]+$/, '').trim();
        li.classList.add('kcro-shade-row');
        li.setAttribute('role', 'button');
        li.setAttribute('tabindex', '0');
        function pick() {
          var list = $('kpuColours');
          var single = $('kpuSingleOptions');
          var target = null;
          if (list) {
            list.querySelectorAll('[data-kpu-colour]').forEach(function (b) {
              var n = (b.querySelector('.kpu-colour-name') || b).textContent.trim();
              if (!target && n.toLowerCase() === name.toLowerCase()) target = b;
            });
          }
          if (target && single && !single.hidden) {
            target.click();
            target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
          } else if (list) {
            attention(list);
          }
        }
        li.addEventListener('click', pick);
        li.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        });
      });
    }
    wireShadeGuide();
    if (window.MutationObserver) {
      new MutationObserver(wireShadeGuide).observe(root, { childList: true, subtree: true });
    }

    // Size and shade finder: the skin tone question and the tone cards answer a tap.
    document.addEventListener('click', function (e) {
      var finder = e.target.closest && e.target.closest('.kpt-finder');
      if (!finder) return;
      var legend = e.target.closest('legend');
      if (legend) {
        var tones = legend.parentNode && legend.parentNode.querySelector('.kpt-tones');
        if (tones) {
          var first = tones.querySelector('input:checked') || tones.querySelector('input');
          if (first) first.focus({ preventScroll: true });
          attention(tones);
        }
        return;
      }
      var label = e.target.closest('.kpt-tones label');
      if (label) {
        setTimeout(function () {
          var submit = finder.querySelector('.kpt-submit');
          if (submit) submit.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'nearest' });
        }, 50);
      }
    });
    // Mark the legend clickable as soon as the finder exists.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        document.querySelectorAll('.kpt-finder legend').forEach(function (lg) { lg.classList.add('kcro-tone-legend'); });
      }).observe(document.body, { childList: true });
    }
  }

  // ---------------------------------------------------------------------------
  // 4. First-screen line next to the sticky Add to cart (fleece tights)
  // ---------------------------------------------------------------------------
  function sizeChartFit(config) {
    var text = String(config.sizeChartText || '');
    var rows = text.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean)
      .map(function (l) { return l.split('|').map(function (c) { return c.trim(); }); });
    if (rows.length < 2) return '';
    var body = rows.slice(1);
    var cols = rows[0].length;
    var weightCol = -1, heightCol = -1;
    for (var c = 1; c < cols; c++) {
      var cell = String(body[0][c] || '');
      if (weightCol < 0 && /\b(lb|kg)\b/i.test(cell)) weightCol = c;
      if (heightCol < 0 && ((/cm/i.test(cell) && /['’′]/.test(cell)) || /\d[.,]\d+\s*m\b/.test(cell))) heightCol = c;
    }
    var metric = !!DATA.metric;
    function nums(cell, part) {
      var parts = String(cell || '').split(';');
      var p = parts.length > 1 ? parts[metric ? 1 : 0] : parts[0];
      return { text: p.trim(), n: (p.match(/\d+(?:[.,]\d+)?/g) || []).map(function (x) { return x.replace(',', '.'); }) };
    }
    var tall = /tall/i.test(String(DATA.line || ''));
    if (tall && heightCol > 0) {
      var a = nums(body[0][heightCol]);
      var z = nums(body[body.length - 1][heightCol]);
      if (metric) {
        if (a.n.length < 1 || z.n.length < 2) return '';
        // Centimetres, or metres as in the French chart (1,70 to 1,85 m).
        var inMetres = !/cm/i.test(z.text) && /\bm\b/.test(z.text);
        var dec = function (x) { return DATA.lang === 'fr' ? String(x).replace('.', ',') : String(x); };
        return t('fitHeight', { low: dec(a.n[0]), high: dec(z.n[z.n.length - 1]) + (inMetres ? ' m' : ' cm') });
      }
      var hs = (a.text.match(/\d+'\d+"?/g) || []);
      var he = (z.text.match(/\d+'\d+"?/g) || []);
      if (!hs.length || !he.length) return '';
      return t('fitHeight', { low: hs[0].replace(/"?$/, '"'), high: he[he.length - 1].replace(/"?$/, '"') });
    }
    if (weightCol > 0) {
      var w1 = nums(body[0][weightCol]);
      var w2 = nums(body[body.length - 1][weightCol]);
      if (!w1.n.length || w2.n.length < 2) return '';
      return t('fitWeight', { low: w1.n[0], high: w2.n[w2.n.length - 1] + (metric ? ' kg' : ' lb') });
    }
    return '';
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) days -= 1;
    }
    return d;
  }

  function deliveryText() {
    var min = Number(MARKET.minDays), max = Number(MARKET.maxDays);
    if (!(min > 0) || !(max >= min)) return '';
    var today = new Date();
    var fmt = function (d) {
      try {
        return d.toLocaleDateString(DATA.dateLocale || 'en-US', { month: 'short', day: 'numeric' });
      } catch (e) {
        return d.toDateString().slice(4, 10);
      }
    };
    return t('arrives', { from: fmt(addBusinessDays(today, min)), to: fmt(addBusinessDays(today, max)) });
  }

  function reviewSummary() {
    var q = DATA.quoli;
    if (typeof q === 'string') {
      try { q = JSON.parse(q); } catch (e) { q = null; }
    }
    var count = 0, rating = 0;
    if (q && Number(q.reviewCount) > 0) {
      count = Number(q.reviewCount);
      rating = Number(q.avgRating);
    } else if (DATA.reviews && Number(DATA.reviews.count) > 0) {
      count = Number(DATA.reviews.count);
      rating = Number(DATA.reviews.rating);
    }
    if (!(count > 0) || !(rating > 0)) return null;
    return { count: count, rating: Math.round(rating * 10) / 10 };
  }

  function setupStrip(root, config) {
    if (!DATA.tights) return;
    var ICON = function (p) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + p + '</svg>'; };
    var items = [];
    var rv = reviewSummary();
    if (rv) {
      var ratingText = DATA.lang === 'fr' ? String(rv.rating).replace('.', ',') : String(rv.rating);
      items.push('<li><span class="kcro-star" aria-hidden="true">&#9733;</span>' + esc(ratingText) + ' (' + rv.count + ' ' + esc(t('reviews')) + ')</li>');
    }
    var fit = sizeChartFit(config);
    if (fit) items.push('<li class="kcro-strip-fit">' + ICON('<path d="M4 20 20 4M7 17l-2-2M10 14l-1.5-1.5M13 11l-2-2M16 8l-1.5-1.5"/>') + esc(fit) + '</li>');
    // CRO batch 2: the promise names its remedy, the delivery is a date and the shipping line
    // gives the charge as well as the free threshold.
    items.push('<li>' + ICON('<path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6z"/><path d="m9 12 2 2 4-4"/>') + esc(t('promiseShort')) + '</li>');
    var by = arrivesBy();
    if (by) items.push('<li>' + ICON('<path d="M2 5h12v12H2zM14 9h4l4 4v4h-8"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>') + esc(t('arrivesBy', { date: by })) + '</li>');
    var fee = feeText();
    if (fee) items.push('<li>' + ICON('<rect x="3" y="8" width="18" height="4"/><path d="M12 8v13M5 12v9h14v-9"/>') + esc(fee) + '</li>');

    function place() {
      var inner = document.querySelector('#kpuStickyCart .kpu-sticky-inner');
      if (!inner) return false;
      if (inner.querySelector('.kcro-strip')) return true;
      var list = document.createElement('ul');
      list.className = 'kcro-strip';
      list.setAttribute('aria-label', t('stripLabel'));
      list.innerHTML = items.join('');
      // Size hint right after the fit range, so it sits on the first mobile screen.
      var hint = sizeHintButton(root, config, 'kcro-strip-hint');
      var fitItem = list.querySelector('.kcro-strip-fit');
      if (hint) {
        var li = document.createElement('li');
        li.className = 'kcro-strip-hint-item';
        li.appendChild(hint);
        if (fitItem) fitItem.insertAdjacentElement('afterend', li); else list.insertBefore(li, list.firstChild);
      }
      inner.insertBefore(list, inner.firstChild);
      return true;
    }
    if (!place()) {
      var n = 0;
      var timer = setInterval(function () { n += 1; if (place() || n > 40) clearInterval(timer); }, 250);
    }
  }

  // ---------------------------------------------------------------------------
  // 5a. Free shipping progress bar in the buy box bag
  // ---------------------------------------------------------------------------
  function setupBagShipping() {
    var threshold = Number(MARKET.threshold);
    var bag = document.getElementById('kpuCart');
    if (!bag || !(threshold > 0)) return;
    var head = bag.querySelector('.kpu-cart-header');
    var original = bag.querySelector('.kpu-shipping-drawer');
    if (!head) return;
    var box = document.createElement('div');
    box.className = 'kcro-ship';
    box.setAttribute('aria-live', 'polite');
    box.hidden = true;
    if (original) original.insertAdjacentElement('beforebegin', box);
    else head.appendChild(box);
    bag.classList.add('kcro-has-ship');

    function render(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var currency = cart.currency || MARKET.currency;
      if (currency !== MARKET.currency) {
        box.hidden = true;
        bag.classList.remove('kcro-has-ship');
        return;
      }
      bag.classList.add('kcro-has-ship');
      var total = Number(cart.total_price) || 0;
      var remaining = threshold - total;
      var pct = Math.max(0, Math.min(100, total / threshold * 100));
      var text = remaining > 0 ? t('shipAway', { amount: money(remaining, currency) }) : t('shipDone');
      box.classList.toggle('is-done', remaining <= 0);
      box.innerHTML = '<p class="kcro-ship__text">' + (remaining > 0
        ? esc(text).replace(esc(money(remaining, currency)), '<strong>' + esc(money(remaining, currency)) + '</strong>')
        : esc(text)) + '</p>' +
        '<div class="kcro-ship__bar" role="progressbar" aria-label="' + esc(t('shipBar')) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-valuetext="' + esc(text) + '"><span style="width:' + pct.toFixed(1) + '%"></span></div>';
      box.hidden = false;
    }
    document.addEventListener('kischt:cart:updated', function (e) {
      render(e.detail && e.detail.cart);
    });
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(render)
      .catch(function () {});
  }

  // ---------------------------------------------------------------------------
  // 5b. 3-pack by default on single pages with packs (never with ?variant=). The 3-pack keeps
  // the shade on screen (Sand single -> Sand 3-pack; a bra colour -> a trio that includes it).
  // When no 3-pack holds that shade, and on persona listings, the single stays.
  // ---------------------------------------------------------------------------
  function setupThreePackDefault(root, config) {
    if (DATA.persona) return;
    // CRO batch 2: Thermal and Sheer Look open on the single pair. Their pack buttons sell
    // Skin Tone packs, so a pack default would rename the heading to another line.
    if (/^(thermal|sheer-look)-fleece-tights$/.test(String(DATA.line || ''))) return;
    var params = new URLSearchParams(location.search);
    var keep = ['variant', 'colour', 'color', 'bundle', 'pack', 'product', 'size'];
    for (var i = 0; i < keep.length; i++) if (params.has(keep[i])) return;
    if (/bot|crawl|spider|slurp|google-inspectiontool|adsbot|mediapartners|lighthouse/i.test(navigator.userAgent || '')) return;
    if (!Array.isArray(config.packs) || config.packs.map(Number).indexOf(3) === -1) return;
    var products = Array.isArray(config.products) ? config.products : [];
    var handle = config.defaultHandle;
    var current = products.filter(function (p) { return p.handle === handle; })[0];
    if (!current) return;
    var threes = (config.bundles || []).filter(function (b) { return Number(b.count) === 3; });
    var target = threes.filter(function (b) { return b.name === current.name; })[0] ||
      threes.filter(function (b) {
        return (b.colours || []).some(function (c) { return String(c).trim() === handle; });
      })[0];
    if (!target) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var btn = root.querySelector('#kpuPacks [data-kpu-pack="3"]');
      var pressed = root.querySelector('#kpuPacks [data-kpu-pack][aria-pressed="true"]');
      if (root.dataset.kpuReady === 'true' && btn && !btn.disabled) {
        clearInterval(timer);
        // Only while the shopper has not picked anything yet.
        if (!pressed || pressed.getAttribute('data-kpu-pack') !== '1' || root.dataset.kcroTouched) return;
        btn.click();
        // Then the 3-pack that holds this shade, if the buy box chose another one.
        var n = 0;
        var pick = setInterval(function () {
          n += 1;
          var card = root.querySelector('#kpuBundles [data-kpu-bundle="' + target.handle + '"]');
          if (card) {
            clearInterval(pick);
            if (card.getAttribute('aria-pressed') !== 'true') card.click();
          } else if (n > 30) {
            clearInterval(pick);
          }
        }, 100);
      } else if (tries > 100) {
        clearInterval(timer);
      }
    }, 100);
    root.addEventListener('click', function () { root.dataset.kcroTouched = 'true'; }, { capture: true, once: true });
  }

  // ===========================================================================
  // CRO batch 2 (1 Nov 2026)
  // ===========================================================================
  var BF = DATA.bf || {};
  function bfOn() { return !!BF.on && Date.now() < Number(BF.end || 0); }
  var FR = DATA.lang === 'fr';
  var FR_SHADES = { porcelain: 'Porcelaine', sand: 'Sable', honey: 'Miel', caramel: 'Caramel', cocoa: 'Cacao', espresso: 'Expresso', noir: 'Noir' };
  var EN_SHADES = { porcelain: 'Porcelain', sand: 'Sand', honey: 'Honey', caramel: 'Caramel', cocoa: 'Cocoa', espresso: 'Espresso', noir: 'Noir' };
  var SHADE_LABEL = { porcelain: 'Fair nude', sand: 'Light nude', honey: 'Medium tan', caramel: 'Medium brown', cocoa: 'Deep brown', espresso: 'Rich deep brown', noir: 'Black sheer look' };

  function rootUrl(path) {
    var base = DATA.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (base.slice(-1) !== '/') base += '/';
    return base + path;
  }

  function dateText(d, long) {
    try {
      return d.toLocaleDateString(DATA.dateLocale || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toDateString().slice(0, 10);
    }
  }

  // "Arrives by": the later end of the market's business-day range (US 7, UK and France 12),
  // the same rule as the batch 1 line and the existing arrival line.
  function arrivesBy(days) {
    var max = Number(days || MARKET.maxDays);
    if (!(max > 0)) return '';
    return dateText(addBusinessDays(new Date(), max));
  }

  function feeText() {
    if (!(Number(MARKET.threshold) > 0)) return '';
    var amount = money(MARKET.threshold, MARKET.currency);
    var fee = money(Number(MARKET.fee) || 0, MARKET.currency);
    if (MARKET.currency === 'USD' && MARKET.country !== 'US') {
      if (!/USD/.test(amount)) amount += ' USD';
    }
    return t('shipFee', { fee: fee, amount: amount });
  }

  // Reads a price as the buy box shows it ($79.95, 79,95 €, £1,234.50) into cents.
  function cents(text) {
    var s = String(text || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var m = s.match(/^(.*?)([.,])(\d{2})$/);
    if (m) return Number(m[1].replace(/[.,]/g, '') + m[3]);
    return Number(s.replace(/[.,]/g, '')) * 100;
  }

  // --- Item 1: size hint from the line's own size chart -------------------------------
  // Example from the middle row (M where the chart has it): the middle of its height and
  // weight ranges, e.g. Tall 5'10", 150 lb = M; Plus 5'3", 240 lb = 2X.
  function sizeExample(config) {
    var text = String(config.sizeChartText || '');
    var rows = text.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean)
      .map(function (l) { return l.split('|').map(function (c) { return c.trim(); }); });
    if (rows.length < 2) return null;
    var body = rows.slice(1);
    var cols = rows[0].length;
    var weightCol = -1, heightCol = -1;
    for (var c = 1; c < cols; c++) {
      var cell = String(body[0][c] || '');
      if (weightCol < 0 && /\b(lb|kg)\b/i.test(cell)) weightCol = c;
      if (heightCol < 0 && ((/cm/i.test(cell) && /['’′]/.test(cell)) || /\d[.,]\d+\s*m\b/.test(cell))) heightCol = c;
    }
    if (weightCol < 0) return null;
    var row = body.filter(function (r) { return r[0] === 'M'; })[0] || body[Math.floor((body.length - 1) / 2)];
    if (!row) return null;
    var metric = !!DATA.metric;
    function part(cell) {
      var parts = String(cell || '').split(';');
      return (parts.length > 1 ? parts[metric ? 1 : 0] : parts[0]).trim();
    }
    function nums(str) {
      return (str.match(/\d+(?:[.,]\d+)?/g) || []).map(function (x) { return Number(x.replace(',', '.')); });
    }
    var w = part(row[weightCol]);
    var wn = nums(w);
    if (/st\b/.test(w)) wn = nums(String(row[weightCol]).split(';').pop());
    if (wn.length < 2) return null;
    var kg = /kg/i.test(w) || /st\b/.test(w) || metric;
    var weight = kg ? Math.round((wn[0] + wn[wn.length - 1]) / 2) : Math.floor((wn[0] + wn[wn.length - 1]) / 2 / 5) * 5;
    var weightText = weight + (kg ? ' kg' : ' lb');
    var heightText = '';
    if (heightCol > 0) {
      var h = part(row[heightCol]);
      if (metric) {
        var hn = nums(h);
        if (/cm/i.test(h) && hn.length >= 2) {
          heightText = Math.round((hn[0] + hn[hn.length - 1]) / 2) + ' cm';
        } else if (hn.length >= 2) {
          var midCm = Math.round((Math.round(hn[0] * 100) + Math.round(hn[hn.length - 1] * 100)) / 2);
          heightText = (midCm / 100).toFixed(2).replace('.', FR ? ',' : '.') + ' m';
        }
      } else {
        var ft = (h.match(/(\d+)['’′]\s*(\d+)/g) || []).map(function (x) {
          var p = x.match(/(\d+)['’′]\s*(\d+)/);
          return Number(p[1]) * 12 + Number(p[2]);
        });
        if (ft.length >= 2) {
          var inches = Math.round((ft[0] + ft[ft.length - 1]) / 2);
          heightText = Math.floor(inches / 12) + '\'' + (inches % 12) + '"';
        }
      }
    }
    var example = heightText ? (FR ? heightText + ' et ' + weightText : heightText + ', ' + weightText) : weightText;
    return { example: example, size: row[0] };
  }

  function openSizeHelp(root) {
    var finder = root.querySelector('.kpt-finder-open');
    if (finder) { finder.click(); return; }
    var guide = document.getElementById('kpuFitButton');
    if (guide) guide.click();
  }

  function sizeHintButton(root, config, cls) {
    var ex = sizeExample(config);
    if (!ex) return null;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = esc(t('sizeHint', ex)) + ' <span class="kcro-hint-link">' + esc(t('sizeHintLink')) + '</span>';
    b.addEventListener('click', function (e) { e.preventDefault(); openSizeHelp(root); });
    return b;
  }

  function setupSizeHint(root, config) {
    if (!DATA.tights) return;
    var sizes = root.querySelector('#kpuSizes');
    if (!sizes || root.querySelector('.kcro-size-hint')) return;
    var b = sizeHintButton(root, config, 'kcro-size-hint');
    if (b) sizes.insertAdjacentElement('afterend', b);
  }

  // --- Item 3, 8, 9: under the page Add to cart -----------------------------------------
  // Replaces the arrival and Christmas lines of the tights upgrades (hidden in the CSS).
  function setupAtcBlock(root) {
    if (!DATA.tights) return;
    var add = root.querySelector('#kpuAddToCart');
    if (!add || root.querySelector('.kcro-atc')) return;
    var ICON = function (p) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + p + '</svg>'; };
    var box = document.createElement('ul');
    box.className = 'kcro-atc';
    var html = '';
    var date = arrivesBy();
    if (date && Number(MARKET.threshold) > 0) {
      var amount = money(MARKET.threshold, MARKET.currency);
      if (MARKET.currency === 'USD' && MARKET.country !== 'US' && !/USD/.test(amount)) amount += ' USD';
      html += '<li>' + ICON('<path d="M2 5h12v12H2zM14 9h4l4 4v4h-8"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>') +
        '<span>' + esc(t('atcDelivery', { date: date, fee: money(Number(MARKET.fee) || 0, MARKET.currency), amount: amount })) + '</span></li>';
    }
    html += '<li>' + ICON('<path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6z"/><path d="m9 12 2 2 4-4"/>') + '<span>' + esc(t('atcReturns')) + '</span></li>';
    box.innerHTML = html;
    var after = add;
    var buyNow = root.querySelector('#kptBuyNow');
    add.insertAdjacentElement('afterend', box);
    root.classList.add('kcro-has-atc');
    // The express buy button of the tights upgrades goes straight after Add to cart.
    if (buyNow && buyNow.parentNode === add.parentNode) box.insertAdjacentElement('beforebegin', buyNow);
  }

  // Business-day ranges in the product information and cart text get their date.
  function datesInText(scope) {
    if (!scope) return;
    var re = FR ? /(\d+) (?:à|a) (\d+) jours (?:ouvrés|ouvrables)(?! en transit)/g : /(\d+) to (\d+) business days(?! in transit)/g;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('[data-kcro-dated], [data-kcro-arrives], .kcro-atc, .kcro-strip')) return NodeFilter.FILTER_REJECT;
        re.lastIndex = 0;
        return re.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var list = [];
    while (walker.nextNode()) list.push(walker.currentNode);
    list.forEach(function (n) {
      re.lastIndex = 0;
      n.nodeValue = n.nodeValue.replace(re, function (all, a, b) {
        return all + t('longArrives', { date: arrivesBy(Number(b)) });
      });
      if (n.parentNode && n.parentNode.setAttribute) n.parentNode.setAttribute('data-kcro-dated', '');
    });
  }

  function setupDeliveryLines(root) {
    // The short "Estimated delivery: 6 to 7 business days" line becomes "Arrives by <date>".
    var line = document.querySelector('.kpu-delivery');
    if (line && !line.hasAttribute('data-kcro-dated')) {
      var strong = line.querySelector('strong');
      var m = strong && strong.textContent.match(/(\d+)\s*(?:to|à|a|-)\s*(\d+)/);
      if (m) {
        var svg = line.querySelector('svg');
        line.innerHTML = (svg ? svg.outerHTML : '') + esc(t('arrivesBy', { date: '' }).replace(/\s*$/, '')) + ' <strong>' + esc(arrivesBy(Number(m[2]))) + '</strong>';
        line.setAttribute('data-kcro-dated', '');
      }
    }
    datesInText(document.querySelector('.kpu-accordions'));
    document.querySelectorAll('.kp-faq-answer, .product-information details, .product-details details').forEach(datesInText);
  }

  // --- Item 2: the 3-pack is the recommended pack; Black Friday line ----------------------
  function setupPackEmphasis(root) {
    var packs = root.querySelector('#kpuPacks');
    if (!packs) return;
    function mark() {
      var three = packs.querySelector('[data-kpu-pack="3"]');
      if (three && !three.classList.contains('kcro-reco')) three.classList.add('kcro-reco');
      if (!bfOn()) return;
      (BF.counts || [3, 6]).forEach(function (n) {
        var b = packs.querySelector('[data-kpu-pack="' + n + '"]');
        if (b && !b.querySelector('.kcro-bf-pack')) {
          var s = document.createElement('span');
          s.className = 'kcro-bf-pack';
          s.textContent = t('bfPack');
          b.appendChild(s);
        }
      });
    }
    mark();
    new MutationObserver(mark).observe(packs, { childList: true, subtree: true });
  }

  function setupBfLine(root) {
    if (!bfOn()) return;
    var bar = root.querySelector('.kpu-price-bar');
    var price = root.querySelector('#kpuPrice');
    var packs = root.querySelector('#kpuPacks');
    if (!bar || !price || !packs) return;
    var line = document.createElement('p');
    line.className = 'kcro-bf-line';
    line.setAttribute('aria-live', 'polite');
    bar.insertAdjacentElement('afterend', line);
    function update() {
      var pressed = packs.querySelector('[data-kpu-pack][aria-pressed="true"]');
      var n = pressed ? Number(pressed.getAttribute('data-kpu-pack')) : 1;
      var text;
      if ((BF.counts || [3, 6]).indexOf(n) !== -1) {
        var c = cents(price.textContent);
        if (!(c > 0)) { line.hidden = true; return; }
        var after = Math.round(c * (100 - Number(BF.pct || 20)) / 100);
        text = t('bfLine', { price: money(after, MARKET.currency || undefined) });
        line.classList.add('is-pack');
      } else {
        text = t('bfHint');
        line.classList.remove('is-pack');
      }
      if (line.textContent !== text) line.textContent = text;
      line.hidden = false;
    }
    update();
    new MutationObserver(update).observe(price, { childList: true, characterData: true, subtree: true });
    new MutationObserver(update).observe(packs, { attributes: true, subtree: true, attributeFilter: ['aria-pressed'] });
  }

  // Product pages without the pack buy box: one line under the price for products in the
  // Black Friday collection, from the selected variant price.
  function setupBfLineTheme() {
    if (!bfOn() || !BF.product || document.querySelector('[data-kpu-root]')) return;
    var host = document.querySelector('#MainContent product-price, #MainContent .product-information .price, #MainContent [class*="price"]');
    // Templates that show no price: the line goes above the Add to cart button instead.
    var button = host ? null : document.querySelector('#MainContent add-to-cart-component, #MainContent button[name="add"]');
    if (!host && !button) return;
    var line = document.createElement('p');
    line.className = 'kcro-bf-line is-pack';
    if (host) host.insertAdjacentElement('afterend', line);
    else button.insertAdjacentElement('beforebegin', line);
    function show(p) {
      var after = Math.round(Number(p) * (100 - Number(BF.pct || 20)) / 100);
      line.textContent = t('bfLine', { price: money(after, MARKET.currency || undefined) });
    }
    show(BF.price);
    document.addEventListener('variant:update', function (e) {
      var v = e.detail && e.detail.resource;
      if (v && v.price != null) show(v.price);
    });
  }

  // --- Item 6: one-tap "Upgrade to the 3-pack" in the bag, theme drawer and cart page ------
  // Only singles of a line that sells the same shade as a 3-pack of the same line:
  // Tall, Skin Tone and Plus Size (six shades) and the three Black Sheer Look lines.
  // Thermal, Sheer Look, Petite and Brown have no 3-pack of their own (their pack buttons sell
  // Skin Tone packs), so they get no offer. Price, saving and currency come from the shop
  // (/products/<handle>.js in the visitor's market), so no new discount is created.
  var SHADE_KEYS = ['porcelain', 'sand', 'honey', 'caramel', 'cocoa', 'espresso'];
  function packHandleFor(handle) {
    var m = String(handle || '').match(/^(kischt-(?:tall|skin-tone|plus-size)-fleece-lined-tights)-(porcelain|sand|honey|caramel|cocoa|espresso)$/);
    if (m) return { pack: m[1] + '-3-pack-' + m[2], key: m[2] };
    m = String(handle || '').match(/^((?:tall-|plus-size-)?black-sheer-look-fleece-lined-tights)$/);
    if (m) return { pack: m[1] + '-3-pack', key: 'noir' };
    return null;
  }
  var productCache = {};
  function productJs(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(rootUrl('products/' + encodeURIComponent(handle) + '.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function itemSize(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) if (/size|taille/i.test(opts[i].name)) return opts[i].value;
    return opts.length ? opts[opts.length - 1].value : (item.variant_title || '');
  }
  var cartCache = { at: 0, p: null };
  function getCart(fresh) {
    if (fresh || !cartCache.p || Date.now() - cartCache.at > 1500) {
      cartCache.at = Date.now();
      cartCache.p = fetch(rootUrl('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cartCache.p;
  }
  function offerFor(item, currency) {
    var map = packHandleFor(item.handle);
    var qty = Number(item.quantity) || 0;
    if (!map || qty < 1 || qty > 2 || item.selling_plan_allocation) return Promise.resolve(null);
    return productJs(map.pack).then(function (p) {
      if (!p || !p.available) return null;
      var size = itemSize(item);
      var v = (p.variants || []).filter(function (x) {
        return x.available && [x.option1, x.option2, x.option3].indexOf(size) !== -1;
      })[0];
      if (!v) return null;
      var single = Number(item.original_price != null ? item.original_price : item.price);
      var pp = Math.round(Number(v.price) / 3);
      var save = single - pp;
      if (!(save > 0)) return null;
      return { item: item, pack: p, variant: v, key: map.key, size: size, single: single, pp: pp, save: save, currency: currency };
    });
  }
  function offerHTML(o) {
    var shade = FR ? (FR_SHADES[o.key] || o.key) : (EN_SHADES[o.key] || o.key);
    var cur = o.currency;
    var html = '<span class="kcro-up__title">' + esc(t('upgradeTitle')) + '</span>' +
      '<span class="kcro-up__detail">' + esc(t('upgradeDetail', { shade: shade, size: o.size, pp: money(o.pp, cur), single: money(o.single, cur), save: money(o.save, cur) })) + '</span>';
    if (bfOn()) html += '<span class="kcro-up__bf">' + esc(t('upgradeBf')) + '</span>';
    return html;
  }
  function post(path, payload) {
    return fetch(rootUrl(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }
  function swap(o) {
    var key = o.key;
    var props = { 'Bundle': EN_SHADES[key] || key, 'Colours': '3 x ' + (SHADE_LABEL[key] || key), 'Pairs per pack': '3' };
    if (key === 'noir') props = { 'Bundle': 'Noir', 'Colours': '3 x Black sheer look', 'Pairs per pack': '3' };
    // Add the 3-pack first, then remove the single, so a failed add leaves the cart as it was.
    return post('cart/add.js', { items: [{ id: o.variant.id, quantity: 1, properties: props }] })
      .then(function () { return post('cart/change.js', { id: o.item.key, quantity: 0 }); })
      .then(function (cart) {
        cartCache.p = null;
        announceCart(cart);
        return cart;
      });
  }
  // Tells the buy box bag and the theme (header count, drawer, cart page) that the cart changed.
  function announceCart(cart) {
    document.dispatchEvent(new CustomEvent('kischt:cart:refresh'));
    if (document.querySelector('[data-kpu-root]')) {
      // The buy box refreshes the theme itself; keep the theme drawer from opening over the bag.
      return;
    }
    var drawers = Array.prototype.slice.call(document.querySelectorAll('cart-drawer-component[auto-open]'));
    drawers.forEach(function (d) { d.removeAttribute('auto-open'); });
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'kischt-cro', data: { source: 'kischt-cro', itemCount: Number(cart && cart.item_count) || 0 } }
      }));
    } finally {
      drawers.forEach(function (d) { d.setAttribute('auto-open', ''); });
    }
  }
  function upgradeButton(o, onError) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kcro-up';
    b.setAttribute('data-kcro-up', o.item.key);
    b.innerHTML = offerHTML(o);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (b.disabled) return;
      b.disabled = true;
      b.setAttribute('aria-busy', 'true');
      swap(o).catch(function () {
        b.disabled = false;
        b.removeAttribute('aria-busy');
        onError(b);
      });
    });
    return b;
  }
  function upgradeError(b) {
    note(b, t('upgradeError'), false, 'kcroUpError');
  }

  // Bag of the pack buy box (tights pages). The bag is redrawn after every change.
  function setupBagUpgrade() {
    var body = document.getElementById('kpuCartBody');
    if (!body) return;
    document.addEventListener('kischt:cart:updated', function (e) {
      var cart = e.detail && e.detail.cart;
      setTimeout(function () {
        if (!cart || !Array.isArray(cart.items)) return;
        var nodes = body.querySelectorAll('.kpu-cart-item');
        if (nodes.length !== cart.items.length) return;
        cart.items.forEach(function (item, i) {
          var host = nodes[i];
          if (!host || host.querySelector('.kcro-up')) return;
          offerFor(item, cart.currency).then(function (o) {
            if (!o || !host.isConnected || host.querySelector('.kcro-up')) return;
            var info = host.querySelector('.kpu-cart-item-info') || host;
            info.appendChild(upgradeButton(o, upgradeError));
          });
        });
      }, 30);
    });
  }

  // Theme cart drawer and cart page (Horizon). Rows are redrawn by the theme, so the offers
  // and dates are added again whenever a cart-items-component changes.
  function setupThemeCart() {
    var busy = false;
    var again = false;
    var lastSig = '';
    // Only rows the shopper can see: the cart page, or the theme drawer while it is open.
    function visibleRows() {
      return Array.prototype.filter.call(document.querySelectorAll('cart-items-component tr[data-key]'), function (r) {
        var dlg = r.closest('dialog');
        return !dlg || dlg.open;
      });
    }
    function run() {
      if (busy) { again = true; return; }
      var rows = visibleRows();
      document.querySelectorAll('[data-kcro-arrives]').forEach(function (el) {
        var d = arrivesBy(Number(el.getAttribute('data-days')) || MARKET.maxDays);
        var text = t('arrivesBy', { date: d });
        if (d && el.textContent !== text) el.textContent = text;
      });
      if (!rows.length) return;
      var sig = Array.prototype.map.call(rows, function (r) { return r.getAttribute('data-key') + (r.querySelector('.kcro-up') ? '+' : ''); }).join('|');
      if (sig === lastSig) return;
      busy = true;
      getCart(true).then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        return Promise.all(cart.items.map(function (item) {
          return offerFor(item, cart.currency).then(function (o) {
            document.querySelectorAll('cart-items-component tr[data-key="' + (window.CSS && CSS.escape ? CSS.escape(item.key) : item.key) + '"]').forEach(function (row) {
              if (row.querySelector('.kcro-up')) return;
              if (!o) return;
              var cell = row.querySelector('.cart-items__details') || row;
              cell.appendChild(upgradeButton(o, upgradeError));
            });
          });
        }));
      }).finally(function () {
        lastSig = Array.prototype.map.call(visibleRows(), function (r) { return r.getAttribute('data-key') + (r.querySelector('.kcro-up') ? '+' : ''); }).join('|');
        busy = false;
        if (again) { again = false; setTimeout(run, 50); }
      });
    }
    var timer = null;
    function queue() { clearTimeout(timer); timer = setTimeout(run, 120); }
    function watch(el) {
      if (el._kcroWatched) return;
      el._kcroWatched = true;
      new MutationObserver(function (list) {
        var ours = list.every(function (m) {
          return Array.prototype.every.call(m.addedNodes, function (n) { return n.nodeType !== 1 || (n.classList && (n.classList.contains('kcro-up') || n.classList.contains('kcro-note'))); }) &&
            Array.prototype.every.call(m.removedNodes, function (n) { return n.nodeType !== 1 || (n.classList && n.classList.contains('kcro-note')); });
        });
        if (!ours) queue();
      }).observe(el, { childList: true, subtree: true });
    }
    document.querySelectorAll('cart-items-component').forEach(watch);
    document.querySelectorAll('cart-drawer-component dialog').forEach(function (d) {
      new MutationObserver(queue).observe(d, { attributes: true, attributeFilter: ['open'] });
    });
    document.addEventListener('cart:update', queue);
    queue();
  }

  // --- Item 3, 7, 8, 9 in the bag of the pack buy box --------------------------------------
  // The upgrades' trust list (with the Christmas line) and its 3-pack button are replaced
  // (hidden in the CSS); express checkout moves to the top of the bag (CSS order).
  function setupBagExtras() {
    var bag = document.getElementById('kpuCart');
    if (!bag) return;
    var wallets = document.getElementById('kptWallets');
    if (wallets) {
      var label = wallets.querySelector('.kpt-wallets-label');
      if (label) label.textContent = t('expressLabel');
      wallets.classList.add('kcro-wallets-top');
    }
    var ICON = function (p) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + p + '</svg>'; };
    document.addEventListener('kischt:cart:updated', function (e) {
      var cart = e.detail && e.detail.cart;
      setTimeout(function () {
        var footer = document.getElementById('kpuCartFooter');
        if (!footer || !cart || !Array.isArray(cart.items) || !cart.items.length) return;
        // Shipping row: the market's real charge, so checkout shows no surprise.
        if (Number(MARKET.threshold) > 0 && cart.currency === MARKET.currency) {
          var rows = footer.querySelectorAll('.kpu-cart-total');
          var row = rows.length > 1 ? rows[1] : null;
          var cell = row && row.lastElementChild;
          if (cell) {
            var free = Number(cart.total_price) >= Number(MARKET.threshold);
            var text = free ? t('free') : money(Number(MARKET.fee) || 0, cart.currency);
            if (cell.textContent !== text) cell.textContent = text;
          }
        }
        var bf = cart.items.some(function (it) {
          return (it.line_level_discount_allocations || []).some(function (a) {
            return /black friday/i.test(String(a.discount_application && a.discount_application.title || ''));
          }) || (it.discounts || []).some(function (d) { return /black friday/i.test(String(d.title || '')); });
        }) || (cart.cart_level_discount_applications || []).some(function (a) { return /black friday/i.test(String(a.title || '')); });
        var list = footer.querySelector('.kcro-bag-trust');
        if (!list) {
          list = document.createElement('ul');
          list.className = 'kcro-bag-trust';
          var checkout = footer.querySelector('.kpu-checkout');
          if (checkout) checkout.insertAdjacentElement('afterend', list); else footer.appendChild(list);
        }
        var items = [];
        if (bf) items.push(ICON('<path d="M20 12 12 20 4 12V4h8z"/><circle cx="8.5" cy="8.5" r="1.5"/>') + '<span>' + esc(t('bfApplied')) + '</span>');
        var d = arrivesBy();
        if (d) items.push(ICON('<path d="M2 5h12v12H2zM14 9h4l4 4v4h-8"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>') + '<span>' + esc(t('arrivesBy', { date: d })) + '</span>');
        if (DATA.tights) items.push(ICON('<path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6z"/><path d="m9 12 2 2 4-4"/>') + '<span>' + esc(t('promiseShort')) + '</span>');
        items.push(ICON('<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>') + '<span>' + esc(t('secure')) + '</span>');
        var html = items.map(function (h) { return '<li>' + h + '</li>'; }).join('');
        if (list.innerHTML !== html) list.innerHTML = html;
      }, 40);
    });
  }

  // ---------------------------------------------------------------------------
  function start() {
    setupPopup();
    setupSwipeNotes(document);
    document.addEventListener('shopify:section:load', function (e) { setupSwipeNotes(e.target); });
    setupThemeCart();
    setupBfLineTheme();
    if (DATA.template === 'cart') datesInText(document.getElementById('MainContent'));

    var root = document.querySelector('[data-kpu-root]:not(.kpu-sticky-host)');
    if (!root) return;
    var config = {};
    try {
      config = JSON.parse(root.querySelector('script[data-kpu-config]').textContent) || {};
    } catch (e) {
      config = {};
    }
    setupGalleryViewer(root);
    setupFeedback(root);
    setupStrip(root, config);
    setupBagShipping();
    setupThreePackDefault(root, config);
    setupSizeHint(root, config);
    setupAtcBlock(root);
    setupDeliveryLines(root);
    setupPackEmphasis(root);
    setupBfLine(root);
    setupBagUpgrade();
    setupBagExtras();
    // The tights upgrades add the finder button after start-up; the size hint uses it on tap.
  }

  onReady(start);
})();
